
import * as Actions from './actions.js'

export const initialState = {
  error: false,
  loading: false,
  roles: [],
  moreNarratives: undefined,
  narrativeLoad: false
}

export default function reducer (state = initialState, action) {
  switch (action.type) {
    case Actions.CLINICAL_IMPRESSIONS:
      return {
        ...initialState,
        loading: true
      }
    case Actions.CLINICAL_IMPRESSIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        roles: action.data
      }
    case Actions.CLINICAL_IMPRESSIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: true
      }
    case Actions.MORE_NARRATIVES:
      return {
        ...state,
        narrativeLoad: true
      }
    case Actions.MORE_NARRATIVES_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const updatedRoles = state.roles.map(r => {
        if (action.data[0].role === r.role) {
          r.narratives = r.narratives.concat(action.data[0].narratives)
        }
        return r
      })

      return {
        ...state,
        narrativeLoad: false,
        error: false,
        roles: updatedRoles
      }
    case Actions.CLEAR_MORE_NARRATIVES:
      return {
        ...state,
        narrativeLoad: false,
        error: false,
        moreNarratives: initialState.moreNarratives
      }
    case Actions.MORE_NARRATIVES_FAILURE:
      return {
        ...state,
        narrativeLoad: false,
        error: true
      }
    default:
      return state
  }
}
